module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsPassport-420b0a28086f26282673490a17b8d4ef.png";